import React, { FC, useRef } from 'react';

import { PlayerView } from '@/scenarios/legacy-player/components/feature-player/ui/player-view/component';

import { UserActionIndicatorProvider } from '../../../feature-player/ui/skin/user-action-indicator/user-action-indicator-provider/component';
import { SportPlayerSkin } from '../SportPlayerSkin/SportPlayerSkin';

import styles from './SportPlayerView.module.css';

interface SportPlayerViewProps {
    contentId: string;
    psid: string;
    withSkin?: boolean;
    onClose?: () => void;
}

export const SportPlayerView: FC<SportPlayerViewProps> = ({
    onClose = (): void => undefined,
    contentId,
    psid,
    withSkin = true,
}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={containerRef}>
            <PlayerView className={styles.root}>
                {withSkin ? (
                    <UserActionIndicatorProvider>
                        <SportPlayerSkin
                            contentId={contentId}
                            psid={psid}
                            className={styles.skin}
                            onClose={onClose}
                            rootContainerRef={containerRef}
                        />
                    </UserActionIndicatorProvider>
                ) : null}
            </PlayerView>
        </div>
    );
};
